import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { Modal } from 'react-bootstrap'

import { httpOk, GET } from 'helpers/api'
import { exportEmployeeReport } from './employeeReportExcel'
import { copyText, countTotalFromArray, formatMoney, returnSign } from 'helpers/helpers'

function Index({ filterData, isActive }) {
	const { t } = useTranslation()

	const [data, setData] = useState([])
	const [loadedFilter, setLoadedFilter] = useState(null)
	const [selectedItem, setSelectedItem] = useState({})
	const [modalDetail, setModalDetail] = useState(false)
	const [overall, setOverall] = useState({})

	async function searchWithFilter() {
		var filterUrl = "/report-cashiers"
		var urlParams = ""

		if (filterData.pos_id)
			urlParams += returnSign(urlParams) + 'pos_id=' + filterData.pos_id
		if (filterData.cashier_id)
			urlParams += returnSign(urlParams) + 'cashier_id=' + filterData.cashier_id
		if (filterData.start_date)
			urlParams += returnSign(urlParams) + 'start_date=' + filterData.start_date
		if (filterData.end_date)
			urlParams += returnSign(urlParams) + 'end_date=' + filterData.end_date

		filterUrl = filterUrl + urlParams

		const response = await GET(filterUrl, {}, { loader: true })
		if (httpOk(response)) {
			setData(response.data.data)
			setOverall(response.data.overall)
			setLoadedFilter(JSON.stringify(filterData))
		}
	}

	function toggleModalDetail(item) {
		setSelectedItem(item)
		setModalDetail(true)
	}

	function share(amount) {
		if (!overall.sales_overall) return '0%'
		return formatMoney(amount * 100 / overall.sales_overall, 1) + '%'
	}

	function exportToExcel() {
		var summary = [['#', t('cashier'), t('working_days'), t('cheques'), t('guests'), t('products'), t('average_cheque'), t('sales_per_day'), t('sales_amount'), t('share_of_sales') + ', %', t('gross_income')]]
		data.forEach((item, index) => summary.push([
			index + 1, item.first_name, Number(item.working_days), Number(item.count_cheque), Number(item.people_number), Number(item.count_products),
			Math.round(item.count_cheque > 0 ? item.total_amount / item.count_cheque : 0),
			Math.round(item.working_days > 0 ? item.total_amount / item.working_days : 0),
			Number(item.total_amount),
			overall.sales_overall ? Math.round(item.total_amount * 1000 / overall.sales_overall) / 10 : 0,
			Number(item.gross),
		]))
		summary.push(['', t('total'), '', Number(overall.cheques_overall), Number(overall.people_overall), Number(overall.products_overall),
			Math.round(overall.cheques_overall > 0 ? overall.sales_overall / overall.cheques_overall : 0), '',
			Number(overall.sales_overall), 100, Number(overall.gross_overall)])
		exportEmployeeReport(t, t('cashier_report'), summary, data, 'total_amount', 'income')
	}

	useEffect(() => {
		// Вкладка не открыта или данные под этот фильтр уже загружены — запрос не шлём
		if (!isActive || !filterData) return
		if (loadedFilter === JSON.stringify(filterData)) return
		searchWithFilter()
	}, [filterData, isActive]) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="card">
				<div className="card-body">
					<div className="d-flex justify-content-between align-items-center mb-3">
						<h5 className="mb-0">{t('cashier_report')}</h5>
						<button className="btn btn-outline-primary btn-sm" title="Excel" onClick={() => exportToExcel()} disabled={!data.length}>
								<i className="uil uil-file-download-alt"></i>
							</button>
					</div>

					<div className="table-responsive">
						<table className="table table-bordered table-hover mb-0">
							<thead>
								<tr>
									<th style={{ 'width': '33px', 'minWidth': '33px', 'maxWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'minWidth': '160px' }}>{t('cashier')}</th>
									<th style={{ 'width': '1%' }} className="text-end text-nowrap">{t('working_days')}</th>
									<th style={{ 'width': '1%' }} className="text-end text-nowrap">{t('cheques')}</th>
									<th style={{ 'width': '1%' }} className="text-end text-nowrap">{t('guests')}</th>
									<th style={{ 'width': '1%' }} className="text-end text-nowrap">{t('products')}</th>
									<th style={{ 'width': '1%' }} className="text-end text-nowrap">{t('average_cheque')}</th>
									<th style={{ 'width': '1%' }} className="text-end text-nowrap">{t('sales_per_day')}</th>
									<th style={{ 'width': '1%' }} className="text-end text-nowrap">{t('sales_amount')}</th>
									<th style={{ 'width': '1%' }} className="text-end text-nowrap">{t('share_of_sales')}</th>
									<th style={{ 'width': '1%' }} className="text-end text-nowrap">{t('gross_income')}</th>
								</tr>
							</thead>
							<tbody>
								{data.map((item, index) => (
									<tr className="cursor" key={index} onClick={() => toggleModalDetail(item)}>
										<td className="text-center">{index + 1}</td>
										<td className="td-ellipsis"
											onClick={() => copyText(item.cashier_login)}
											title={item.cashier_login}>
											{item.first_name}
										</td>
										<td className="text-end text-nowrap">{item.working_days}</td>
										<td className="text-end text-nowrap">{formatMoney(item.count_cheque)}</td>
										<td className="text-end text-nowrap">{formatMoney(item.people_number)}</td>
										<td className="text-end text-nowrap">{formatMoney(item.count_products)}</td>
										<td className="text-end text-nowrap">{formatMoney(item.count_cheque > 0 ? item.total_amount / item.count_cheque : 0)}</td>
										<td className="text-end text-nowrap">{formatMoney(item.working_days > 0 ? item.total_amount / item.working_days : 0)}</td>
										<td className="text-end text-nowrap fw-semibold">{formatMoney(item.total_amount)}</td>
										<td className="text-end text-nowrap">{share(item.total_amount)}</td>
										<td className="text-end text-nowrap">{formatMoney(item.gross)}</td>
									</tr>
								))}
								{data.length > 0 &&
									<tr className="table-light fw-bold">
										<td></td>
										<td>{t('total')}</td>
										<td></td>
										<td className="text-end text-nowrap">{formatMoney(overall.cheques_overall)}</td>
										<td className="text-end text-nowrap">{formatMoney(overall.people_overall)}</td>
										<td className="text-end text-nowrap">{formatMoney(overall.products_overall)}</td>
										<td className="text-end text-nowrap">{formatMoney(overall.cheques_overall > 0 ? overall.sales_overall / overall.cheques_overall : 0)}</td>
										<td></td>
										<td className="text-end text-nowrap">{formatMoney(overall.sales_overall)}</td>
										<td className="text-end text-nowrap">100%</td>
										<td className="text-end text-nowrap">{formatMoney(overall.gross_overall)}</td>
									</tr>
								}
								{loadedFilter && data.length === 0 &&
									<tr>
										<td colSpan="11" className="text-center text-muted py-4">{t('no_data')}</td>
									</tr>
								}
							</tbody>
						</table>
					</div>
				</div>
			</div>

			<Modal show={modalDetail} animation={false} size="lg" centered onHide={() => setModalDetail(false)}>
				<Modal.Body>
					<h3 className="mb-3">{selectedItem.first_name}</h3>
					<div className="table-responsive table-fixed inventory-modal-height">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ 'width': '33px', 'minWidth': '33px' }} className="text-center">#</th>
									<th>{t('name2')}</th>
									<th className="text-end text-nowrap">{t('price')}</th>
									<th className="text-end text-nowrap">{t('sale_price')}</th>
									<th className="text-end text-nowrap">{t('quantity')}</th>
									<th className="text-end text-nowrap">{t('sales_amount')}</th>
									<th className="text-end text-nowrap">{t('income')}</th>
								</tr>
							</thead>
							<tbody>
								{selectedItem?.products?.map((item, index) => (
									<tr key={index}>
										<td className="text-center">{index + 1}</td>
										<td>{item.name}</td>
										<td className="text-end text-nowrap">{formatMoney(item.price)}</td>
										<td className="text-end text-nowrap">{formatMoney(item.sale_price)}</td>
										<td className="text-end text-nowrap">{formatMoney(item.total_quantity)}</td>
										<td className="text-end text-nowrap">{formatMoney(item.total_amount)}</td>
										<td className="text-end text-nowrap">{formatMoney(item.income)}</td>
									</tr>
								))}
								<tr className="table-light fw-bold">
									<td></td>
									<td>{t('total')}</td>
									<td></td>
									<td></td>
									<td className="text-end text-nowrap">{formatMoney(countTotalFromArray(selectedItem?.products, 'total_quantity'))}</td>
									<td className="text-end text-nowrap">{formatMoney(countTotalFromArray(selectedItem?.products, 'total_amount'))}</td>
									<td className="text-end text-nowrap">{formatMoney(countTotalFromArray(selectedItem?.products, 'income'))}</td>
								</tr>
							</tbody>
						</table>
					</div>
				</Modal.Body>
			</Modal>
		</>
	)
}

export default Index
